import { useState, useEffect, useRef, useCallback, Fragment } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import Nav from '../../../UI/Nav/Nav';
import ListItem from '../../../UI/List/ListItem';
import UnorderedList from '../../../UI/List/UnorderedList';

import styles from './PageNavigation.module.css';

const PageNavigation = props => {

  const [isOpen, setIsOpen] = useState(false);
  const [pathname, setPathname] = useState(false);
  const pageNavigation = useRef(null);
  const location = useLocation();


  /*!
  * Determine if an element is in the viewport
  * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
  * @param  {Node}    elem The element
  * @return {Boolean}      Returns true if element is in the viewport
  */
  const isInViewport = (elem) => {
    var distance = elem.getBoundingClientRect();
    return (
      distance.top >= 0 &&
      distance.left >= 0 &&
      distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      distance.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  /**
   * Native scrollTo with callback
   * @param offset - offset to scroll to
   * @param callback - callback function
   */
  function scrollTo(offset, callback) {
    const fixedOffset = offset.toFixed();
    const onScroll = function () {
            if (window.pageYOffset.toFixed() === fixedOffset) {
                window.removeEventListener('scroll', onScroll)
                callback(!isOpen)
            }
        }

    window.addEventListener('scroll', onScroll)
    onScroll()
    window.scrollTo({
        top: offset,
        behavior: 'smooth'
    })
  }

  const handleScroll = useCallback(e => {
    console.log('scrolled');
    if(isOpen) {
      if(!isInViewport(pageNavigation.current)) {
        setIsOpen(false);
      }
    }
  }, [
    isOpen,
    pageNavigation
  ]);

  useEffect(() => {

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); 
    }
  }, [handleScroll])

  useEffect(() => {

    const currentPathname = derivePathname(location.pathname);
    setPathname(currentPathname);

    setIsOpen(false);
  }, [location]);

  const toggleMenu = () => {
    if(!isOpen) {
      scrollTo(0, setIsOpen);
    } else {
      setIsOpen(!isOpen);
    }
  }

  const derivePathname = location => {
    if (location === '/') {
      return 'HOME';
    }

    const pathnameIndex = location.lastIndexOf('/') + 1;

    return location.substring(pathnameIndex);
  }

  const menuItems = [
    {
      label: 'Home',
      linkTo: '/',
    },
    {
      label: 'Hideout',
      linkTo: 'hideout'
    },
    {
      label: 'Whitepaper',
      linkTo: 'whitepaper'
    },
    {
      label: 'Acknowledgements',
      linkTo: 'acknowledgements'
    },
  ];

  const menuItemsMap = menuItems.map((menuItem, index) => <NavLink key={index} to={menuItem.linkTo}>
    <ListItem className={styles.ListItem}>
      {menuItem.label}
    </ListItem>
  </NavLink>);

  return (
    <Fragment>

      <button className={`${styles.menuButton} ${isOpen ? styles.menuButtonOpen : ''}`} onClick={toggleMenu}>
        <i className="ri-menu-line"></i>
      </button>

      <h2 className={styles.navTitle}>{pathname}</h2>

      {(isOpen && menuItemsMap) && <Nav ref={pageNavigation} className={styles.PageNavigation}>

        <UnorderedList className={styles.UnorderedList}>

          {menuItemsMap}

        </UnorderedList>
      </Nav>}


      <Nav ref={pageNavigation} className={`${styles.PageNavigation} ${styles.PageNavigationDesktop}`}>

        <UnorderedList className={styles.UnorderedList}>

          {menuItemsMap}

        </UnorderedList>
      </Nav>
      

    </Fragment>
  );
};

export default PageNavigation;